export default {
    "Bem vindo(a) ao": "Bienvenue sur",
    "Entre com suas credenciais": "Entrez vos identifiants",
    "do Ginfo abaixo": "de Ginfo ci-dessous",
    "Empresa": "Entreprise",
    "empresa_login": "Entreprise",
    "Selecione a empresa": "Sélectionnez l'entreprise",
    "E-mail": "E-mail",
    "Senha": "Mot de passe",
    "Lembrar de mim": "Se souvenir de moi",
    "Entrar": "Se connecter",
    "Solicite seu acesso": "Demandez votre accès",

    "Portugues": "Portugais",
    "Mercosul": "Mercosur",
    "Ingles": "Anglais",
    "Frances": "Français",
    "Alemao": "Allemand",
    "Holandes": "Néerlandais",
    "Carregando": "Chargement",
    'TODOS': 'TOUS',
    'BELGIUM': 'BELGIQUE',
    'GERMANY': 'ALLEMAGNE',
    'SELECIONE_O_PAIS': 'Sélectionnez le pays',
    'PAIS': 'Pays',
    "inicio": "Accueil",
    "bem_vindo": "Bienvenue sur",
    "ginfo_analytics": "GINFO Analytics",
    "informacoes_inteligentes": "Des informations intelligentes pour des décisions plus rapides, sûres et stratégiques",
    "acessados_recentemente": "Consultés récemment",
    "buscar_relatorio": "Rechercher un rapport",
    "nenhum_relatorio_encontrado": "Aucun rapport trouvé.",
    "acesso_power_bi": "Accès à Power BI",
    "ajuda": "Aide",
    "sair": "Se déconnecter",
    "agora": "maintenant",
    "ha": "il y a",
    "minutos": "min",
    "horas": "h",
    "ontem": "hier",
    "dias": "jours",
    "semanas": "semaines",
    "buscar_abrir_relatorio": "Rechercher et ouvrir le rapport",
    "mostrar_senha": "Afficher le mot de passe",
    "ocultar_senha": "Masquer le mot de passe",
    "esqueceu_senha": "Mot de passe oublié ?",
    "login_frase_inicio": "De meilleures décisions commencent avec",
    "login_frase_destaque": "la bonne information",
    "login_frase_2": "le bon moment",
    "login_frase_3": "le bon endroit",
    "recarregar_relatorio": "Actualiser le rapport",
    "fechar_aba": "Fermer l'onglet",
    "horarios_atualizacao": "Horaires de mise à jour",
    "tutorial_desta_tela": "Tutoriel de cet écran",
    "fechar": "Fermer",
    "carregando_tutorial": "Chargement du tutoriel...",
    "tutorial_indisponivel": "Tutoriel indisponible pour cet écran pour le moment.",
    "passo": "Étape"

}
